import getAutocompleteAddress from '../api/addressVerificationApi/getAutocompleteAddress';
import postAddressValidation from '../api/addressVerificationApi/postAddressValidation';
export const US_ISO2 = 'US';
export const US_ISO3 = 'USA';
export const US_NAME = 'United States of America';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function removeUndefined(obj) {
  // side-effects includes original object is modified
  Object.keys(obj).forEach(key => obj[key] === undefined && delete obj[key]);
  return obj;
}
export function normalizeApiAddress(address) {
  if (!address) {
    return null;
  }
  const {
    address1,
    address2,
    city,
    state,
    postCode: zip,
    country,
    valid: verified = false
  } = address;
  return removeUndefined({
    address1,
    address2,
    city,
    state,
    zip,
    country,
    verified
  });
}
export const addressToString = _ref => {
  let {
    address1,
    city,
    state,
    zip,
    country
  } = _ref;
  return `${address1 || ''}, ${city || ''}, ${state || ''} ${zip || ''}, ${country || ''}`.replace(/,[\s,]*/, ', ').replace(/\s,/, ',').replace(/(^[,\s]+|[,\s]+$)/, '');
};
export const isInternational = countryCode => countryCode !== US_ISO2 && countryCode !== US_ISO3 && countryCode !== US_NAME;
export async function validateAddress(_ref2) {
  let {
    address1,
    address2,
    city,
    state,
    zip: postCode,
    country
  } = _ref2;
  let root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  return (await postAddressValidation({
    address1,
    address2,
    city,
    state,
    postCode,
    country: country || US_ISO2
  }, root)).map(address => normalizeApiAddress({
    country: 'US',
    ...address
  }));
}
export async function autocompleteAddress(_ref3) {
  let {
    address1,
    city,
    state
  } = _ref3;
  let root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  return (await getAutocompleteAddress({
    address1,
    city,
    state
  }, root)).map(address => normalizeApiAddress({
    country: 'US',
    ...address
  }));
}